import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { ModalidadeCursoPorExtenso } from 'src/tipos'

export const colunaModalidade = (): TabelaColuna => ({
  Chave: 'Modalidade',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{ModalidadeCursoPorExtenso[linha.Modalidade]}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 160 }}>Modalidade</div>
})
